/**
 * avatars/blocky-avatar-held-items.js
 * Mixin quản lý đồ vật cầm tay cho BlockyAvatar.
 */

import * as THREE from 'three';

class HeldItemsHolder {
  setHeldItem(itemType) {
    if (this.attachmentSlots.heldItem) {
      if (this.attachmentSlots.heldItem.parent) {
        this.attachmentSlots.heldItem.parent.remove(this.attachmentSlots.heldItem);
      }
      this.attachmentSlots.heldItem = null;
    }

    // Reset góc cánh tay phải về vị trí tự nhiên
    if (this.parts.rightArm) {
      this.parts.rightArm.rotation.set(0, 0, 0);
    }
    if (this.parts.rightForearm) {
      this.parts.rightForearm.rotation.set(0, 0, 0);
    }

    if (!itemType || itemType === 'none') return;

    const item = this.itemsLib.createHeldItem(itemType);
    const isArticulated = !!this.parts.rightForearm;
    const attachTarget = isArticulated ? this.parts.rightForearm : this.parts.rightArm;
    const forearmH = this.dimensions.armH * 0.5;
    const armH = this.dimensions.armH;

    if (itemType === 'guitar') {
      item.position.set(0.04, this.dimensions.torsoH * 0.45, this.dimensions.torsoD * 0.78);
      this.parts.torso.add(item);
    } else if (itemType === 'ganh_hang_rong') {
      // ĐÒN GÁNH TRE: Đặt cân đối trên vai phải nhân vật
      item.position.set(this.dimensions.torsoW * 0.35, this.dimensions.torsoH * 0.95, 0);
      this.parts.torso.add(item);
      if (isArticulated) {
        this.parts.rightArm.rotation.set(-0.45, 0.2, 0.15);
        this.parts.rightForearm.rotation.set(-0.35, 0, 0);
      } else {
        this.parts.rightArm.rotation.set(-0.6, 0.25, 0.2);
      }
    } else if (itemType === 'clipboard') {
      // TƯ THẾ CẦM BẢNG GHI CHÚ STEAM: Cẳng tay nâng ngực, mặt giấy A4 ngửa lên trên đúng chiều
      if (isArticulated) {
        this.parts.rightArm.rotation.set(-0.25, -0.15, 0.08);
        this.parts.rightForearm.rotation.set(-1.05, -0.1, 0.05);
        item.position.set(0.04, -forearmH + 0.12, 0.14);
        item.rotation.set(0.35, 0, 0);
        attachTarget.add(item);
      } else {
        this.parts.rightArm.rotation.set(-0.75, -0.22, 0.15);
        item.position.set(0.04, -armH + 0.12, 0.14);
        item.rotation.set(0.35, 0, 0);
        attachTarget.add(item);
      }
    } else if (itemType === 'dien_thoai_smartphone') {
      // SMARTPHONE SHIPPER: Cẳng tay hơi nâng, lòng bàn tay ngửa cầm máy xem map
      if (isArticulated) {
        this.parts.rightArm.rotation.set(-0.35, -0.1, 0.05);
        this.parts.rightForearm.rotation.set(-0.85, 0, 0);
        item.position.set(0, -forearmH + 0.06, 0.08);
        item.rotation.set(0.45, 0, 0);
        attachTarget.add(item);
      } else {
        this.parts.rightArm.rotation.set(-0.65, -0.15, 0.1);
        item.position.set(0, -armH + 0.06, 0.08);
        item.rotation.set(0.45, 0, 0);
        attachTarget.add(item);
      }
    } else if (itemType === 'keyboard') {
      // BÀN PHÍM CƠ ANH HÙNG BÀN PHÍM: Cầm ngang ngực sẵn sàng combat gõ phím
      if (isArticulated) {
        this.parts.rightArm.rotation.set(-0.3, -0.15, 0.05);
        this.parts.rightForearm.rotation.set(-0.75, -0.1, 0.1);
        item.position.set(0.06, -forearmH + 0.08, 0.15);
        item.rotation.set(0.35, -0.1, 0.2);
        attachTarget.add(item);
      } else {
        this.parts.rightArm.rotation.set(-0.6, -0.2, 0.1);
        item.position.set(0.06, -armH + 0.08, 0.15);
        item.rotation.set(0.35, -0.1, 0.2);
        attachTarget.add(item);
      }
    } else if (itemType === 'coc_tra_da') {
      // CỐC TRÀ ĐÁ: Tay hơi nâng cốc phía trước
      if (isArticulated) {
        this.parts.rightArm.rotation.set(-0.15, 0, 0);
        this.parts.rightForearm.rotation.set(-0.55, 0, 0);
        item.position.set(0, -forearmH + 0.08, 0.1);
        attachTarget.add(item);
      } else {
        this.parts.rightArm.rotation.set(-0.35, 0, 0);
        item.position.set(0, -armH + 0.08, 0.1);
        attachTarget.add(item);
      }
    } else if (itemType === 'cap_tap') {
      // Cặp táp xách bên đùi tự nhiên, quai xách lọt vào nắm tay phải
      const yPos = isArticulated ? -forearmH - 0.04 : -armH - 0.04;
      item.position.set(0, yPos, 0);
      attachTarget.add(item);
    } else if (itemType === 'am_tra_bat_trang') {
      // ẤM TRÀ BÁT TRÀNG: Hạ thấp để tay cầm đúng vào đỉnh quai xách đồng
      const yPos = isArticulated ? -forearmH - 0.28 : -armH - 0.28;
      item.position.set(0, yPos, 0);
      attachTarget.add(item);
    } else if (itemType === 'vali_keo') {
      // Cần kéo vali vừa tầm với bàn tay phải
      const yPos = isArticulated ? -forearmH + 0.05 : -armH + 0.05;
      item.position.set(0.12, yPos, 0.05);
      attachTarget.add(item);
    } else if (this.isLongHeldItem(item, itemType)) {
      // Dựng đứng song song thân, chân gậy chạm sàn, thân gậy nằm ngay trước nắm tay
      item.rotation.set(0, 0, 0);
      item.updateMatrixWorld(true);
      const box = new THREE.Box3().setFromObject(item);
      const { legH, torsoH, armD } = this.dimensions;
      const groundY = isArticulated ? -(legH + torsoH - armH * 0.5) : -(legH + torsoH);
      item.position.set(0, groundY + 0.01 - box.min.y, armD / 2 + 0.03);
      attachTarget.add(item);
    } else if (itemType === 'bua_nham_thach') {
      const yPos = isArticulated ? -forearmH + 0.12 : -armH + 0.12;
      item.position.set(0, yPos, this.dimensions.armD * 0.3);
      item.rotation.set(Math.PI / 3, 0, 0);
      attachTarget.add(item);
    } else if (itemType === 'khiên_tinh_the') {
      const yPos = isArticulated ? -forearmH * 0.5 : -armH * 0.5;
      item.position.set(0.08, yPos, 0.08);
      attachTarget.add(item);
    } else {
      // Góc cầm mặc định: Xoay 90° hướng về phía trước (+Z) như cầm gậy, cầm kiếm, bình nước
      const yPos = isArticulated ? -forearmH + 0.06 : -armH + 0.06;
      item.position.set(0, yPos, this.dimensions.armD * 0.4);
      item.rotation.set(Math.PI / 2, 0, 0);
      attachTarget.add(item);
    }
    this.attachmentSlots.heldItem = item;
    this.enforceShadowPolicy();
  }

  /**
   * Đồ cầm dài trên 1m (gậy, đinh ba, lưỡi hái...) và cung: cầm dựng đứng thay vì chĩa ngang ra trước
   */
  isLongHeldItem(item, itemType) {
    if (itemType === 'cung_bang') return true;
    const prevRot = item.rotation.clone();
    item.rotation.set(0, 0, 0);
    item.updateMatrixWorld(true);
    const height = new THREE.Box3().setFromObject(item).getSize(new THREE.Vector3()).y;
    item.rotation.copy(prevRot);
    return height >= 1.0;
  }
}

export function registerAvatarHeldItemMethods(proto) {
  Object.getOwnPropertyNames(HeldItemsHolder.prototype).forEach((name) => {
    if (name !== 'constructor') {
      Object.defineProperty(proto, name, {
        value: HeldItemsHolder.prototype[name],
        writable: true,
        configurable: true,
        enumerable: false
      });
    }
  });
}
